<div
  class="opened model-adj-column-overlay"
  [ngStyle]="{ height: overlayHeight + 'px' }"
  #overlayRef
>
  <mat-spinner
    class="model-adj-column-spinner"
    [ngStyle]="{ top: spinnerTop + 'px' }"
    active
    medium
    #spinnerRef
    [diameter]="48"
  ></mat-spinner>
</div>
